import dayjs from 'dayjs';

export * from './client-details';
export * from './invite-client';

// CLIENT DASHBOARD ENUMS

export enum STATUS_TYPES {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  PROSPECT = 'Prospect',
  ADVICE = 'Advice',
  MANAGED = 'Managed',
  REVIEW = 'Review',
  GONE_AWAY = 'GoneAway',
  TRANSIT = 'Transit',
  ARCHIVED = 'Archived',
}

export enum CLIENT_TYPES {
  PERSON = 'Person',
  BUSINESS = 'Business',
}

export enum ADVICE_TYPES {
  RETIREMENT_ADVICE = 'Retirement Advice',
  MORTGAGE_PROTECTION = 'Mortgage Protection',
  MANAGING_AND_GROWING_YOUR_WEALTH = 'Managing and Growing your Wealth',
  LEAVEING_AND_PROTECTING_YOUR_LEGACY = 'Leaving and Protecting your Legacy',
  PROTECTING_YOURSELF_AND_LEGACY = 'Protecting yourself and legacy',
}

export enum STAGE_TYPES {
  INITIAL_MEETING = 'INITIAL_MEETING', // remove
  FACT_FIND = 'FACT_FIND',
  ADVISE = 'ADVISE',
  MANAGED = 'Managed',
  PROTECTION_PLANNING = 'PROTECTION_PLANNING',
  INVESTMENT_MANAGEMENT = 'INVESTMENT_MANAGEMENT',
  MORTGAGES = 'MORTGAGES',
  ESTATE_PLANNING = 'ESTATE_PLANNING',
  EQUITY_RELEASE = 'EQUITY_RELEASE',
  RETIREMENT_PLANNING = 'RETIREMENT_PLANNING',
  RECOMMENDATION = 'RECOMMENDATION',
}

export enum PLANNING_TYPES {
  Discovery = 'Discovery',
  ADVISE = 'Advice',
  MANAGED = 'Managed',
  PARA_PLANNING = 'Paraplanning',
  PROSPECT = 'Prospect',
  RECOMMENDATION = 'Recommendation',
}

export enum USER_ROLE {
  SUPER_ADMINISTRATOR = 'Super Administrator',
  FINANCIAL_ADVISOR = 'Financial Advisor',
  PARAPLANNER = 'Paraplanner',
  ADMINISTRATOR = 'Administrator',
  EXECUTIVE_OFFICER = 'Executive Officer',
  COMPLIANCE_OFFICER = 'Compliance Officer',
  RELATIONSHIP_MANAGER = 'Relationship Manager',
}

// CLIENT DASHBOARD TYPES
export interface IViewClientDashboardRequest {
  clientName: string;
  clientType: CLIENT_TYPES[] | [];
  planningStatus: STAGE_TYPES[] | [];
  adviceTypes: ADVICE_TYPES[] | [];
  clientStatus: STATUS_TYPES[] | [];
  pageSize: number;
  pageIndex: number;
  desc: true;
}
export interface IClientCardItem {
  clientData: any;
  caseID: string;
  clientActivationDate: string;
  clientCreationDate: string;
  advisorID: string;
  retailUserID: string;
  clientID: string;
  retailClientName: string;
  clientType: CLIENT_TYPES;
  clientStatus: STATUS_TYPES;
  adviceTypes: ADVICE_TYPES[];
  workflowInstanceID: string;
  stage: STAGE_TYPES;
  clientReferenceNumber: string;
  planningStatus: PLANNING_TYPES;
  clientOnboarded: boolean;
  clientRegistered: boolean;
}

export interface IViewClientDashboardResponse {
  clientCardItems: IClientCardItem[];
  totalPages: number;
}

export interface IViewClientDashboardCountRequest {
  clientName: string;
  meetingTimeOption: string;
  leadStatus: string;
  adviceType: string;
}

export interface IViewClientDashboardCountResponse {
  totalClientCount: number;
  prospectiveClientCount: number;
  existingClientCount: number;
}

// -------------------------------------------------------------------------------

export interface ISetupMeetingRequest {
  title: string;
  date: string;
  time: string;
  duration: number;
  timezone: string;
  retailInvestorUserID: string;
  advisorMeetingType: string;
  meetingType: string;
  taskID: string;
}

export interface ISetupMeetingResponse {
  resp: {
    meetingID: string;
  };
}

export interface ICalculateRiskRequest {
  sessionToken: string;
  answers: number[];
  isSubmitted: boolean;
}

export interface ICalculateRiskResponse {
  response: {
    advisorID: string;
    retailUserID: string;
    advisorUserID: string;
    riskSummaryStatus: string;
    questionnaireResultID: string;
  };
}

export interface ISubmitRiskQuestionsRequest {
  sessionToken: string;
  answers: number[];
  isSubmitted: boolean;
}

export interface ISubmitRiskQuestionsResponse {
  response: {
    advisorID: string;
    retailUserID: string;
    advisorUserID: string;
    riskSummaryStatus: string;
    questionnaireResultID: string;
  };
}

export interface ISetupInitialMeetingRequest {
  caseID: string;
  meetingInfo: {
    advisorID: string;
    retailUserID: string;
    isMeetingNotProceed: boolean;
    isMeetingPreviouslyCompleted: boolean;
    title: string;
    meetingDate: string;
    meetingNotes: string;
  };
}

export interface IGetGDPRStatusRequest {
  caseID: string;
  reportType: string;
}

export interface IGetGDPRStatusResponse {
  reports: [
    {
      id: string;
      status: string;
      createdAt: string;
      updatedAt: string;
      reportStatus: string;
      reportType: string;
      reportFileName: string;
      reportSignature: boolean;
      documentID: string;
    },
  ];
}

export interface IViewInitialMeetingRequest {
  retailUserID: string;
}

export interface IViewInitialMeetingResponse {
  response: {
    id: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    advisorID: string;
    advisorUserID: string;
    retailUserID: string;
    isMeetingNotProceed: boolean;
    isMeetingPreviouslyCompleted: boolean;
    title: string;
    meetingDateTime: string;
    meetingNotes: string;
  };
}

export interface ICaptureInitialMeetingRequest {
  caseID: string;
  title: string;
  meetingDateTime: Date | null;
  meetingNotes: string;
  isMeetingPreviouslyCompleted: boolean;
  isMeetingNotProceed: boolean;
  retailUserID: string;
  advisorID: string;
}

export interface ICaptureInitialMeetingResponse {
  id: string;
}

export interface IReportStatusRequest {
  caseID: string;
}

export interface IReportStatusResponse {
  reportIsReady: boolean;
  reportDocumentID: string;
}

export interface IViewClientMeetingRequest {
  meetingTimeOption: string;
  meetingStatus: string;
  pageSize: number;
  pageIndex: number;
}

export interface IMeetingCardItem {
  meetingID: string;
  startTime: string;
  endTime: string;
  duration: number;
  topic: string;
  startURL: string;
  meetingPlatform: string;
  additionalContent: string;
  caseID: string;
  advisorID: string;
  advisorUserID: string;
  retailUserID: string;
  retailClientName: string;
  advisorTaskType: string;
  meetingStatus: string;
  adviceTypes: string[] | null;
  meetingType: string;
  meetingDetail: string;
}

export interface IViewClientMeetingResponse {
  meetingCardItems: IMeetingCardItem[];
  totalPages: number;
}

export interface IViewRetailClientsResponse {
  retails: {
    investorID: string;
    retailUserID: string;
    retailClientName: string;
  }[];
  totalPages: number;
}

export interface IViewAdvisorUserRequest {
  userStatus: string | 'Active' | 'Pending';
  fullName: string;
  Role: string | 'Super User' | 'Financial Advisor' | 'Paraplanner' | 'Investment Manager' | 'Task Admin';
  pageSize: number;
  pageIndex: number;
}

export interface IAdvisorUserData {
  userID: string;
  email: string;
  fullName: string;
  roles: string[];
  userStatus: 'Active' | 'Pending';
}

export interface IViewAdvisorUserResponse {
  userCardItems: IAdvisorUserData[];
  totalPages: number;
}

export interface IGDPR {
  isSigned: boolean;
  signedDate?: string; // Optional if isSigned is false
}

export interface IRTQ {
  isSigned: boolean;
  signedDate?: string; // Optional if isSigned is false
}

export interface IAdvisor {
  advisorID: string;
  advisorUserID: string;
  name: string;
  bio: string; // Displayed in the advisor card
  pendingMeeting: boolean; // Display "Schedule Meeting" button if true
  logoID: string;
}

export interface IClientDashboardDataResponse {
  caseID: string;
  clientStatus: string;
  gdpr: IGDPR;
  rtq?: IRTQ; // Optional; hide RTQ card if omitted
  advisor: IAdvisor;
  aboutYou: boolean; // true: enable; false: disable
  protectionPlanning?: boolean; // Optional; hide card if omitted
  investmentPlanning?: boolean; // Optional; hide card if omitted
}

export interface IProfileSetupProgressResponse {
  progressPercentage: number;
  firmProfileProgress: {
    uploadCompanyLogo: boolean;
    manageFirmRoles: boolean | null;
    modelPortfolios: boolean;
    riskAssessment: boolean;
    financialPlanning: boolean;
    adviceTemplates: boolean;
    factFindFieldConfig: boolean;
    productConfig: boolean;
    billingInvoice: boolean;
  };
  myUserProfileProgress: {
    updateProfilePicture: boolean;
    addCertificateNExpertise: boolean;
    addWorkingHours: boolean;
    setNotificationPref: boolean;
  };
  firmProfileSetupComplete: boolean;
}

export interface IRequestScheduleMeetingRequest {
  activityInstanceID: string;
  advisorID: string;
  advisorUserID: string;
  retailUserID: string;
  meetingTitle: string;
  meetingDetails: string;
  meetingType: string;
  advisorMeetingType: string;
  duration: number;
  isMeetingScheduled: boolean;
  meetingID: string;
}

export interface IViewScheduleMeetingRequest {
  activityInstanceID: string;
}

export interface IViewScheduleMeetingRequestFromEmail {
  sessionToken: string;
}

export interface IViewScheduleMeetingResponse {
  response: {
    id: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    activityInstanceID: string;
    advisorID: string;
    advisorUserID: string;
    retailUserID: string;
    meetingTitle: string;
    meetingDetails: string;
    meetingType: string;
    duration: number;
    meetingID: string;
    isMeetingScheduled: boolean;
  };
}

export interface Meeting {
  advisorFirstName: string;
  advisorLastName: string;
  meetingID: string;
  meetingDetail: string;
  meetingTopic: string;
  startTime: string; // ISO 8601 format
  duration: number; // Duration in minutes
  inviteMeetingRequestID: string;
  isMeetingCompleted: boolean;
  isMeetingScheduled: boolean;
  meetingType?: string;
}

export interface IViewMeetingsResponse {
  meetingRequest: Meeting[];
  upcomingMeetings: Meeting[];
  pastMeetings: Meeting[];
}

export interface IAcceptMeetingRequest {
  date: string | null;
  time: string | null;
  timezone: string;
  advisorMeetingType: string;
  meetingType: string;
  inviteMeetingRequestID: string;
  guests: string[];
}

export interface IRescheduleMeetingRequest {
  meetingID: string;
  date: string;
  time: string;
  timezone: string;
}

export interface ICancelMeetingRequest {
  meetingID: string;
  cancelReason: string;
}

export interface IAcceptMeetingFromEmailRequest {
  request: {
    agenda: string;
    taskID: string;
    meetingAddress: object;
    date: string;
    time: string;
    timezone: string;
    advisorMeetingType: string;
    inviteMeetingRequestID: string;
    guests: string[];
  };
}

export interface IAcceptMeetingFromEmailResponse {
  id: string;
}

export interface IViewAdvisorMeetingSlotsFromEmailRequest {
  request: {
    timeZone: string;
    sessionToken: string;
    advisorUserID: string;
    startTime: dayjs.ConfigType;
    endTime: dayjs.ConfigType;
    duration: number;
  };
}

export interface IViewAdvisorMeetingSlotsTimeStartEnd {
  startTime: dayjs.ConfigType;
  endTime: dayjs.ConfigType;
}

export interface IViewAdvisorMeetingSlotsTimeSlots {
  date: string;
  timeSlots: IViewAdvisorMeetingSlotsTimeStartEnd[];
}

export interface IViewAdvisorMeetingSlotsFromEmailResponse {
  response: {
    timeSlots: IViewAdvisorMeetingSlotsTimeSlots[];
  };
}

export interface IClientGrowByAUM {
  firmId: string;
  firmName: string;
  month: dayjs.ConfigType;
  newClients: number;
  cumulativeClients: number;
}

export interface IViewMonthlyAUM {
  firmId: string;
  firmName: string;
  valuationDate: dayjs.ConfigType;
  totalFirmValue: number;
  currency: string;
}

export interface IViewTopClientsByAUM {
  clientId: string;
  firstName: string;
  lastName: string;
  totalAum: number;
  firmId: string;
  currency: string;
  clientName: string;
}

export interface IViewTopAdvisorsByAUM {
  advisorId: string;
  firstName: string;
  lastName: string;
  totalAum: number;
  firmId: string;
  currency: string;
  clientName: string;
}

export interface IViewAUMByAccountType {
  accountType: string;
  totalAum: number;
  firmId: string;
  currency: string;
}

export interface IViewAUMBySecurities {
  securityName: string;
  totalValue: number;
  firmId: string;
  currency: string;
}

export interface IViewAUMByPortfolios {
  portfolioName: string;
  totalPortfolioValue: number;
  firmId: string;
  currency: string;
}

export interface ITopPortfoliosYTD {
  portfolioId: string;
  firmId: string;
  firmName: string;
  portfolioName: string;
  portfolioCreatedAt: dayjs.ConfigType;
  totalPurchaseValue: number;
  totalCurrentValue: number;
  ytdPercentageChange: number;
}

export interface ITopSecuritiesYTD {
  securityId: string;
  firmId: string;
  firmName: string;
  securitySymbol: string;
  securityName: string;
  currency: string;
  purchasePrice: number;
  currentPrice: number;
  totalValue: number;
  ytdPercentageChange: number;
  valuationDate: dayjs.ConfigType;
}

export interface IViewMISDasboardResponse {
  totalClients: number;
  totalAccounts: number;
  totalAum: number;
  totalRevenue: number;
  averagePortfolio: number;
  currency: string;
  clientGrowthByAum: IClientGrowByAUM[];
  monthlyAum: IViewMonthlyAUM[];
  top10ClientAUMs: IViewTopClientsByAUM[];
  top10AdvisorAUMs: IViewTopAdvisorsByAUM[];
  aumByAccountTypes: IViewAUMByAccountType[];
  aumBySecurities: IViewAUMBySecurities[];
  aumByPortfolios: IViewAUMByPortfolios[];
  topPortfoliosYTD: ITopPortfoliosYTD[];
  topSecuritiesYTD: ITopSecuritiesYTD[];
}

export interface IAdvisorScheduleMeetingResponse {
  meetingID: string;
}

export interface IAdvisorScheduleMeetingRequest {
  meetingTitle: string;
  meetingDetails: string;
  meetingType: string;
  advisorMeetingType: string;
  duration: number;
  date: string;
  time: string;
  timezone: string;
  retailUserID: string;
}

export interface IViewAuthorsOptionsResponse {
  response: {
    authorID: string;
    authorName: string;
  }[];
}

export interface ISearchDocumentsRequest {
  folderIDs: any[];
  documentName?: string;
  categoryIDs?: string[];
  subCategoryIDs?: string[];
  documentTypes?: string[];
  clientIDs?: string[];
  creatorIDs?: string[];
  status?: string[];
  keyword?: string;
  pageSize: number;
  pageIndex: number;
  skipPagination: boolean;
  folderPath?: string[];
}

export interface ISearchDocumentsResponse {
  response: [
    {
      documentID: string;
      documentName: string;
      version: string;
      category: string;
      authorName: string;
      status: string;
      updatedAt: string;
      bucketName: number;
    },
  ];
}

export interface IGetDocumentHistoryResponse {
  history: [
    {
      id: string;
      timestamp: string;
      userFullName: string;
      userEmail: string;
      eventType: string;
      documentName: string;
      categoryID: string;
      folderID: string;
      documentStatus: string;
      categoryName: string;
      oldDocumentStatus: string;
      oldFolderID: string;
      oldCategoryID: string;
      oldCategoryName: string;
      editComment: string;
    },
  ];
}
